export const module = {
  info: {
    name: 'voip-vendor',
    caption: 'voip vendor',
    viewGroup: 'fasfreeroute-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true
}

export default module
